import classNames from 'classnames';
import { Spinner } from 'components/Spinner/Spinner';
import PropTypes from 'prop-types';
import './SpinnerOverlay.scss';

export const SpinnerOverlay = ({ message, children, className }) => {
  const spinnerOverlayClassName = classNames('SpinnerOverlay', {
    [className]: !!className,
  });

  return (
    <div data-testid="spinner-overlay" className={spinnerOverlayClassName}>
      <Spinner />
      {message && (
        <span
          data-testid="spinner-overlay-message"
          className="SpinnerOverlay-message"
        >
          {message}
        </span>
      )}
      {children}
    </div>
  );
};

SpinnerOverlay.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  message: PropTypes.string,
};
